







































































































































































































































































































import "@/extensions";
import {Component, Mixins, Watch} from "vue-property-decorator";
import Http from "@/mixins/http";
import Toast from "@/mixins/toast";
import LocalData from "@/mixins/local-data";
import MarketSelect from "@/components/MarketSelect.vue";
import MultiSelect from "@/components/MultiSelect.vue";
import CollapseCard from "@/components/UI/CollapseCard.vue";

import {SelectBox, SelectMarket} from "@/interfaces/global-data";
import {
    GetTaskInfo,
    IExportTask,
    ProductInfoResponseProperty,
    TaskInfoFilterType,
} from "@/interfaces/server-data";
import {Modal} from "ant-design-vue";
import {Moment} from "moment";

type EntityFilterKeys =
    | TaskInfoFilterType.group
    | TaskInfoFilterType.category
    | TaskInfoFilterType.subcategory
    | TaskInfoFilterType.format
    | TaskInfoFilterType.region
    | TaskInfoFilterType.cluster;

interface AssortmentFilterOptions {
    groups: SelectBox<number>[];
    categories: SelectBox<number>[];
    subcategories: SelectBox<number>[];
    formats: SelectBox<number>[];
    regions: SelectBox<number>[];
    clusters: SelectBox<number>[];
}

@Component({
  components: {
      MarketSelect,
      MultiSelect,
      CollapseCard,
  },
  computed: {
      TaskInfoFilterType(): typeof TaskInfoFilterType {
          return TaskInfoFilterType;
      },
  },
})

export default class DataExport extends Mixins(Http, Toast, LocalData) {
    dataExportMarket = localStorage.getItem('data_export_market');
    selectMarket: SelectMarket | null = this.dataExportMarket ? JSON.parse(this.dataExportMarket) : null;

    pagination: any = {
        current: 1,
        pageSize: 10,
        total: 0,
    };

    exportFileType: 'COMPETITOR_PRODUCTS_EXPORT' | 'LAST_PRICES_EXPORT' = 'COMPETITOR_PRODUCTS_EXPORT';
    competitorsDateRangeValues: any = [];
    assortmentExportDate: Moment | null = null;

    get defaultIntSelectBox(): Array<SelectBox<number>> {
        return [{ value: 0, label: this.$t('regular.common.all') as string }];
    }

    assortmentGroupIds: number[] = [];
    assortmentCategoryIds: number[] = [];
    assortmentSubcategoryIds: number[] = [];
    assortmentFormatIds: number[] = [];
    assortmentRegionIds: number[] = [];
    assortmentClusterIds: number[] = [];
    assortmentInternalCode: string = '';

    assortmentFilterOptions: AssortmentFilterOptions = {
        groups: [],
        categories: [],
        subcategories: [],
        formats: [],
        regions: [],
        clusters: [],
    };

    private assortmentOptionPropertyNames: Record<EntityFilterKeys, keyof AssortmentFilterOptions> = {
        [TaskInfoFilterType.group]: 'groups',
        [TaskInfoFilterType.category]: 'categories',
        [TaskInfoFilterType.subcategory]: 'subcategories',
        [TaskInfoFilterType.format]: 'formats',
        [TaskInfoFilterType.region]: 'regions',
        [TaskInfoFilterType.cluster]: 'clusters',
    };

    private assortmentFilterPropertyNames: Record<EntityFilterKeys, keyof DataExport> = {
        [TaskInfoFilterType.group]: 'assortmentGroupIds',
        [TaskInfoFilterType.category]: 'assortmentCategoryIds',
        [TaskInfoFilterType.subcategory]: 'assortmentSubcategoryIds',
        [TaskInfoFilterType.format]: 'assortmentFormatIds',
        [TaskInfoFilterType.region]: 'assortmentRegionIds',
        [TaskInfoFilterType.cluster]: 'assortmentClusterIds',
    };

    tableData: IExportTask[] = [];

    computedTableFields: any[] = [
      {dataIndex: 'taskId', title: this.$t('dataExport.table.taskId') as string, width: 100,},
      {dataIndex: 'tradingId', title: this.$t('dataExport.table.tradingCompany') as string, ellipsis: true, scopedSlots: { customRender: 'tradingName' }, width: 200},
      {dataIndex: 'fileName', title: this.$t('dataExport.table.fileName') as string, ellipsis: true, scopedSlots: { customRender: 'fileName' }},
      {dataIndex: 'status', title: this.$t('dataExport.table.status') as string, ellipsis: true, scopedSlots: { customRender: 'status' }, width: 200},
      {dataIndex: 'createdAt', title: this.$t('dataExport.table.createdAt') as string, ellipsis: true, customRender: (el: string) => new Date(el).toLocaleString(), width: 230},
      {dataIndex: 'actions', title: this.$t('dataExport.table.actions') as string, scopedSlots: { customRender: 'actions' }, width: 144},
    ];

    isTableLoading: boolean = false;

    exportTaskListFetchInterval: number = 0;

    mounted() {
        this.startIntervalFetching();
        if (this.isMarketSelected && this.exportFileType === 'LAST_PRICES_EXPORT') {
            this.fetchAllAssortmentFilterOptions();
        }
    }

    beforeDestroy() {
        this.stopIntervalFetching();
    }

    @Watch('exportFileType')
    onExportFileTypeChange(newVal: string) {
        if (newVal === 'LAST_PRICES_EXPORT' && this.isMarketSelected) {
            this.fetchAllAssortmentFilterOptions();
        }
    }

    updateSelectMarket(market: SelectMarket) {
        this.selectMarket = market;

        localStorage.setItem('data_export_market', JSON.stringify(market));
        this.$log.debug('Export market - updateSelectMarket', market);

        this.stopIntervalFetching();

        this.pagination.current = 1;
        this.pagination.total = 0;

        this.assortmentGroupIds = [];
        this.assortmentCategoryIds = [];
        this.assortmentSubcategoryIds = [];
        this.assortmentFormatIds = [];
        this.assortmentRegionIds = [];
        this.assortmentClusterIds = [];
        this.assortmentInternalCode = '';

        this.$nextTick(() => {
            this.startIntervalFetching();
            if (this.isMarketSelected && this.exportFileType === 'LAST_PRICES_EXPORT') {
                this.fetchAllAssortmentFilterOptions();
            }
        });
    }

    onTableChange(pagination: any) {
        this.pagination.current = pagination.current;

        this.fetchExportTaskList();
    }

    handleResetBtnClick() {
        this.exportFileType = 'COMPETITOR_PRODUCTS_EXPORT';
        this.competitorsDateRangeValues = [];
        this.assortmentExportDate = null;
        this.assortmentGroupIds = [];
        this.assortmentCategoryIds = [];
        this.assortmentSubcategoryIds = [];
        this.assortmentFormatIds = [];
        this.assortmentRegionIds = [];
        this.assortmentClusterIds = [];
        this.assortmentInternalCode = '';
    }

    getLoadOptionsFilter(taskType: EntityFilterKeys): GetTaskInfo {
        const tradingId = this.selectMarket!.id;
        const empty: number[] = [];
        switch (taskType) {
            case TaskInfoFilterType.group:
                return { type: taskType, tradingId, groups: empty, categories: empty, subcategory: empty, storeFormat: [], storeRegion: [], storeCluster: [] };
            case TaskInfoFilterType.category:
                return { type: taskType, tradingId, groups: this.assortmentGroupIds.slice().realValuesOrEmpty(), categories: empty, subcategory: empty, storeFormat: [], storeRegion: [], storeCluster: [] };
            case TaskInfoFilterType.subcategory:
                return { type: taskType, tradingId, groups: this.assortmentGroupIds.slice().realValuesOrEmpty(), categories: this.assortmentCategoryIds.slice().realValuesOrEmpty(), subcategory: empty, storeFormat: [], storeRegion: [], storeCluster: [] };
            case TaskInfoFilterType.format:
                return { type: taskType, tradingId, groups: empty, categories: empty, subcategory: empty, storeFormat: [], storeRegion: [], storeCluster: [] };
            case TaskInfoFilterType.region:
                return { type: taskType, tradingId, groups: empty, categories: empty, subcategory: empty, storeFormat: this.assortmentFormatIds.slice().realValuesOrEmpty(), storeRegion: [], storeCluster: [] };
            case TaskInfoFilterType.cluster:
                return { type: taskType, tradingId, groups: empty, categories: empty, subcategory: empty, storeFormat: this.assortmentFormatIds.slice().realValuesOrEmpty(), storeRegion: this.assortmentRegionIds.slice().realValuesOrEmpty(), storeCluster: [] };
        }
    }

    fetchAssortmentFilterOptions(type: EntityFilterKeys, refName: string) {
        this.$nextTick(() => {
            const ref = this.$refs[refName];
            if (ref && (ref as any).toggleLoading) {
                (ref as any).toggleLoading(true);
            }
        });

        this.httpGetProductInfo(this.getLoadOptionsFilter(type))
            .then((res) => {
                const options = res.data ? res.data[ProductInfoResponseProperty[type]] : [];
                const key = this.assortmentOptionPropertyNames[type];
                if (options && options.length) {
                    this.assortmentFilterOptions[key] = [
                        { value: 0, label: this.$t('regular.common.all') as string },
                        ...options.map((i: { id: number; name: string }) => ({ value: i.id, label: i.name })),
                    ];
                } else {
                    this.assortmentFilterOptions[key] = [{ value: 0, label: this.$t('regular.common.all') as string }];
                }
            })
            .catch(() => {
                this.assortmentFilterOptions[this.assortmentOptionPropertyNames[type]] = [{ value: 0, label: this.$t('regular.common.all') as string }];
                this.showError(this.$t('http.errors.loadFilters3') as string);
            })
            .finally(() => {
                this.$nextTick(() => {
                    const ref = this.$refs[refName];
                    if (ref && (ref as any).toggleLoading) {
                        (ref as any).toggleLoading(false);
                    }
                });
            });
    }

    fetchAllAssortmentFilterOptions() {
        if (!this.selectMarket) return;
        this.fetchAssortmentFilterOptions(TaskInfoFilterType.group, 'exportGroupsRef');
        this.fetchAssortmentFilterOptions(TaskInfoFilterType.category, 'exportCategoriesRef');
        this.fetchAssortmentFilterOptions(TaskInfoFilterType.subcategory, 'exportSubcategoriesRef');
        this.fetchAssortmentFilterOptions(TaskInfoFilterType.format, 'exportFormatsRef');
        this.fetchAssortmentFilterOptions(TaskInfoFilterType.region, 'exportRegionsRef');
        this.fetchAssortmentFilterOptions(TaskInfoFilterType.cluster, 'exportClustersRef');
    }

    updateAssortmentFiltersData(type: EntityFilterKeys) {
        const defaultVal = this.defaultIntSelectBox.map((i) => i.value);
        switch (type) {
            case TaskInfoFilterType.group:
                this.assortmentCategoryIds = defaultVal.slice();
                this.assortmentSubcategoryIds = defaultVal.slice();
                this.fetchAssortmentFilterOptions(TaskInfoFilterType.category, 'exportCategoriesRef');
                this.fetchAssortmentFilterOptions(TaskInfoFilterType.subcategory, 'exportSubcategoriesRef');
                break;
            case TaskInfoFilterType.category:
                this.assortmentSubcategoryIds = defaultVal.slice();
                this.fetchAssortmentFilterOptions(TaskInfoFilterType.subcategory, 'exportSubcategoriesRef');
                break;
            case TaskInfoFilterType.format:
                this.assortmentRegionIds = defaultVal.slice();
                this.assortmentClusterIds = defaultVal.slice();
                this.fetchAssortmentFilterOptions(TaskInfoFilterType.region, 'exportRegionsRef');
                this.fetchAssortmentFilterOptions(TaskInfoFilterType.cluster, 'exportClustersRef');
                break;
            case TaskInfoFilterType.region:
                this.assortmentClusterIds = defaultVal.slice();
                this.fetchAssortmentFilterOptions(TaskInfoFilterType.cluster, 'exportClustersRef');
                break;
        }
    }

    handleAssortmentFilterChanged(value: number[], type: EntityFilterKeys) {
        const current = this[this.assortmentFilterPropertyNames[type] as keyof DataExport] as number[];
        if (value.length && !LocalData.compareTwoArrays(value, current)) {
            (this as any)[this.assortmentFilterPropertyNames[type]] = value.slice().realValuesOrEmpty();
            this.updateAssortmentFiltersData(type);
        }
    }

    private dayToIsoRange(day: Moment | null): { from: string; to: string } | null {
        if (!day || !day.isValid()) {
            return null;
        }
        return {
            from: day.clone().startOf('day').toISOString(),
            to: day.clone().endOf('day').toISOString(),
        };
    }

    handleStartExportButtonClick() {
        const filters: any = {
            tradingId: this.selectMarket!.id,
        };

        if (this.exportFileType === 'COMPETITOR_PRODUCTS_EXPORT') {
            filters.dateTimeFrom = this.competitorsDateRangeValues[0];
            filters.dateTimeTo = this.competitorsDateRangeValues[1];
        } else {
            const range = this.dayToIsoRange(this.assortmentExportDate);
            if (!range) {
                return;
            }
            filters.dateTimeFrom = range.from;
            filters.dateTimeTo = range.to;
            const g = this.assortmentGroupIds.slice().realValuesOrEmpty();
            const c = this.assortmentCategoryIds.slice().realValuesOrEmpty();
            const s = this.assortmentSubcategoryIds.slice().realValuesOrEmpty();
            const f = this.assortmentFormatIds.slice().realValuesOrEmpty();
            const r = this.assortmentRegionIds.slice().realValuesOrEmpty();
            const cl = this.assortmentClusterIds.slice().realValuesOrEmpty();
            filters.groups = g.length ? g : null;
            filters.categories = c.length ? c : null;
            filters.subcategories = s.length ? s : null;
            filters.storeFormats = f.length ? f : null;
            filters.storeRegions = r.length ? r : null;
            filters.storeClusters = cl.length ? cl : null;
            const internalCodeTrim = this.assortmentInternalCode ? this.assortmentInternalCode.trim() : '';
            filters.internalCode = internalCodeTrim || null;
        }

        this.httpCreateExportTask({
            taskType: this.exportFileType,
            filters,
        }).then(() => {
            this.fetchExportTaskList();

            this.showInfo(this.$t('dataExport.messages.exportStarted') as string);

            this.competitorsDateRangeValues = [];
            this.assortmentExportDate = null;
        }).catch((e) => {
            this.showError(this.$t('dataExport.messages.exportStartError') as string);

            console.error(e);
        })
    }

    get isStartExportBtnDisabled() {
        if (!this.isMarketSelected) {
            return true;
        }

        if (this.exportFileType === 'COMPETITOR_PRODUCTS_EXPORT') {
            return this.competitorsDateRangeValues.length < 2 || this.competitorsDateRangeValues.some((value: any) => !value);
        } else {
            return !this.assortmentExportDate || !this.assortmentExportDate.isValid();
        }
    }

    get isMarketSelected() {
        return this.selectMarket && this.selectMarket.id !== -1;
    }

    fetchExportTaskList(dontShowLoader: boolean = false) {
        if (!dontShowLoader) {
            this.isTableLoading = true;
        }

        this.httpFetchExportTaskList({
            tradingId: this.selectMarket!.id,
            page: this.pagination.current - 1,
            size: this.pagination.pageSize,
        }).then((response) => {
            this.tableData = response.data.content;
            this.pagination.total = response.data.totalElements;
        }).finally(() => {
            this.isTableLoading = false;
        })
    }

    startIntervalFetching() {
        if (this.isMarketSelected) {
            this.exportTaskListFetchInterval = setInterval(() => {
                this.fetchExportTaskList(true);
            }, 10000);

            this.fetchExportTaskList();
        }
    }

    stopIntervalFetching() {
        clearInterval(this.exportTaskListFetchInterval);
    }

    handelDeleteBtnClick(exportTask: IExportTask) {
        Modal.confirm({
            title: this.$t('dataExport.messages.confirmDeleteTitle') as string,
            content: (this.$t('dataExport.messages.confirmDeleteContent') as string) + (['COMPLETED', 'CANCELLED'].includes(exportTask.status) ? (this.$t('dataExport.messages.fileAlsoDeleted') as string) : ''),
            centered: true,
            okText: this.$t('dataExport.messages.confirmDeleteOk') as string,
            cancelText: this.$t('shared.actions.cancel') as string,
            onOk: () => {
                this.httpDeleteExportTask(exportTask.taskId).then(() => {
                    this.showInfo(this.$t('dataExport.messages.fileDeleted') as string);

                    this.fetchExportTaskList();
                }).catch((e) => {
                    this.showError(this.$t('dataExport.messages.deleteError') as string)

                    console.error(e);
                })
            },
        });
    }

    handleDownloadBtnClick(task: IExportTask) {
        this.httpGetTokenForDownloadExportFile(task.taskId).then(response => {
            const token = response.data.token;

            const downloadUrl = process.env.VUE_APP_BACKEND_URL ?
                `${process.env.VUE_APP_BACKEND_URL}/api/export/download/${task.taskId}?token=${token}`
                : `/api/export/download/${task.taskId}?token=${token}`;
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = task.fileName as string;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        })
    }

    handelExportCancelBtnClick(taskId: number) {
        this.httpCancelExportTask(taskId).then(() => {
            this.showInfo(this.$t('dataExport.messages.exportCancelled') as string);

            this.fetchExportTaskList();
        });
    }
}
